import { useEffect, useState } from "react";
import classNames from "classnames";
import { useParams, useLocation, useNavigate } from "react-router";
import { safetyGasApi } from "@/apis";
import "./index.less";

const videoNames = [
  "宝速德储罐部件介绍",
  "宝速德储罐操作重点",
  "宝速德储罐节假日注意事项",
  "宝速德储罐介绍",
  "低温贮槽操作说明",
  "低温贮槽使用介绍",
];

const SafetyGasDetail = () => {
  const navigate = useNavigate();

  const { id = "" } = useParams();
  const { pathname } = useLocation();
  const isOnlyInfo = pathname.includes("/weiDetail");
  const [gasInfo, setGasInfo] = useState<SafeyGasDetailData>();
  const [isVideo, setIsVideo] = useState<boolean>(false);

  useEffect(() => {
    safetyGasApi.getSafeyGasDetail(id).then((res) => {
      setGasInfo(res);
      const title = res?.title;
      const isVideo = videoNames.includes(title);
      setIsVideo(isVideo);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goListPage = () => {
    navigate("/safetyGas");
  };

  return (
    <article className={classNames({ "mall-wrappper noheader": isOnlyInfo })}>
      <main className={classNames({ "mall-main": isOnlyInfo })}>
        <div className="max-width detail-info-wrapper">
          <h2>{gasInfo?.title}</h2>
          <p className="time">{gasInfo?.createTime}</p>
          <p className="line"></p>
          {!isVideo ? (
            <div
              className="detail-info"
              dangerouslySetInnerHTML={{ __html: gasInfo?.text || "" }}
            ></div>
          ) : (
            <div className="detail-info">
              <video controls width="100%">
                <source
                  src={`/${gasInfo?.title}.mp4`}
                  type="video/mp4"
                />
              </video>
            </div>
          )}
          {!isOnlyInfo && (
            <>
              <p className="line"></p>
              <button className="back-btn pointer" onClick={goListPage}>
                返回
              </button>
            </>
          )}
        </div>
      </main>
    </article>
  );
};

export default SafetyGasDetail;
